import z from "zod"

export const ACTION_ON_TRANSLATION_CLICK = z.enum(["bookmark", "speak"])
export type ActionOnTranslationClick = z.infer<
  typeof ACTION_ON_TRANSLATION_CLICK
>

export const GUTENBERG_LANGUAGE_KEYS = {
  de: "gutenbergDe",
  fr: "gutenbergFr",
} as const
